import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'sanitizeHtml' })
export class SanitizeHtmlPipe implements PipeTransform {
	private sanitizer = inject(DomSanitizer);

	transform(v: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(v);
	}
}
